import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { motion } from "framer-motion";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import defaultImage from "src/components/image/Image_not_available.png";

const ConstructionCard = ({
  id,
  projectImage: image,
  title,
  location,
  area,
  projectStatus: status,
  projectType,
  details,
  typeOfBuilding,
  index = 0,
}) => {
  const history = useHistory();
  const baseImageBucketUrl = process.env.REACT_APP_S3_IMAGE_BUCKET_URL;
  const projectTitle = title || "Homely project";

  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1],
        delay: Math.min(index * 0.07, 0.28),
      }}
      whileHover={{ y: -5 }}
    >
      <Card
        elevation={0}
        sx={{
          overflow: "hidden",
          backgroundColor: "transparent",
          cursor: "pointer",
        }}
        onClick={() =>
          history.push(`/construction/${id}`, {
            id,
            image,
            title: projectTitle,
            location,
            area,
            status,
            projectType,
            details,
            typeOfBuilding,
          })
        }
      >
        <Box
          sx={{
            position: "relative",
            aspectRatio: "1.18 / 1",
            overflow: "hidden",
            backgroundColor: "#dedbd2",
          }}
        >
          <Box
            component="img"
            src={image ? `${baseImageBucketUrl}${image}` : defaultImage}
            alt={projectTitle}
            loading="lazy"
            sx={{
              display: "block",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 800ms cubic-bezier(0.22, 1, 0.36, 1)",
              "&:hover": { transform: "scale(1.045)" },
            }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(0deg, rgba(25,24,21,0.58), transparent 52%)",
              pointerEvents: "none",
            }}
          />
          {(status || projectType) && (
            <Typography
              sx={{
                position: "absolute",
                left: 2.5,
                bottom: 2.5,
                color: "white",
                fontSize: "0.65rem",
                fontWeight: 600,
                letterSpacing: "0.13em",
                textTransform: "uppercase",
              }}
            >
              {status || projectType}
            </Typography>
          )}
          <ArrowOutwardIcon
            sx={{
              position: "absolute",
              right: 2.5,
              bottom: 2.5,
              color: "white",
              fontSize: 20,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            pt: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                mb: 0.65,
                color: "#9a794b",
                fontSize: "0.64rem",
                fontWeight: 600,
                letterSpacing: "0.13em",
                textTransform: "uppercase",
              }}
            >
              {location || typeOfBuilding || "Homely construction"}
            </Typography>
            <Typography
              component="h2"
              sx={{
                color: "#292720",
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontSize: "1.5rem",
                lineHeight: 1.2,
              }}
            >
              {projectTitle}
            </Typography>
          </Box>
          {area && (
            <Typography
              sx={{
                flexShrink: 0,
                pt: 1,
                color: "#706d64",
                fontSize: "0.74rem",
              }}
            >
              {area} sq.ft.
            </Typography>
          )}
        </Box>
      </Card>
    </motion.div>
  );
};

export default ConstructionCard;
